import React, { PureComponent, Fragment } from 'react'
import DocumentTitle from 'react-document-title'
import {
  node, string, func, oneOfType, shape,
} from 'prop-types'
import appendQuery from 'append-query'
import humps from 'humps'
import { withI18n } from '@active/react-utils/i18n'
import Responsive from '@active/react-utils/components/Responsive'
import includes from 'lodash/fp/includes'

import Header from './Header'
import Footer from '../common/Footer'
import Sidebar from './Sidebar'
import { getUrlParams } from '../../shared/utils/commonUtils'
import BrowserSupport from '../common/BrowserSupport'
import { CommonProvider } from '../../widgets/widgetCommonContext'
import './PassportMenuPage.scss'

const originUrlParams = getUrlParams()
const urlParams = Object.keys(originUrlParams)
  .reduce((acc, key) => Object.assign(acc, { [humps.camelize(key)]: originUrlParams[key] }), {})
const menuPageDefaultParams = {
  redirect_uri: window.location.href,
  client_id: window.passportClientId,
}

const login = (customParams = {}) => {
  const params = {
    ...originUrlParams,
    ...menuPageDefaultParams,
    ...customParams,
  }
  window.location.href = appendQuery(`${window.location.origin}/page/signin`, params)
}
const logoutCallback = (customParams = {}) => {
  const params = {
    ...menuPageDefaultParams,
    ...originUrlParams,
    ...customParams,
  }
  window.location.href = appendQuery(`${window.keycloakAPIServerHost}/auth/realms/active/signout`, params)
}

const actions = { login, logoutCallback: logoutCallback }

class PassportMenuPage extends PureComponent {
  static propTypes = {
    i18n: func.isRequired,
    widget: oneOfType([func, shape({}), node]).isRequired,
    titleKey: string,
    sideType: string.isRequired,
  }

  static defaultProps = {
    titleKey: 'Active',
  }

  constructor(props) {
    super(props)
    const passportAPIServerHost = window.passportAPIServerHost || window.location.origin
    this.state = {
      params: Object.assign(urlParams, {
        passportAPIServerHost,
        keycloakAPIServerHost: window.keycloakAPIServerHost || `${passportAPIServerHost}/v5`,
      }),
      showSideBar: true,
    }
    this.setShowSideBar = this.setShowSideBar.bind(this)
  }

  setShowSideBar = showSideBar => {
    this.setState({ showSideBar })
  }

  render() {
    const {
      widget: Widget, titleKey, i18n, sideType, ...rest
    } = this.props
    const { params, showSideBar } = this.state

    // TODO: move to PassportRoute
    const userAg = window.navigator.userAgent
    if (includes('MSIE')(userAg) || includes('Trident')(userAg)) {
      return (
        <>
          <DocumentTitle title={i18n(titleKey)} />
          <div className="passport-ui-message__container">
            <BrowserSupport />
            <Footer />
          </div>
        </>
      )
    }

    return (
      <>
        <DocumentTitle title={i18n(titleKey)} />
        <Header {...params} />
        <div className="passport-menupage">
          {
            urlParams.leftNavSuppressed !== 'true' && showSideBar
            && (
              <Responsive eqAbove="md">
                <Sidebar {...params} sideType={sideType} />
              </Responsive>
            )
          }
          <div className="passport-ui-fullpage">
            <CommonProvider
              value={{ passportAPIServerHost: params.passportAPIServerHost }}
            >
              <Widget {...actions} {...params} sideType={sideType} {...rest} setShowSideBar={this.setShowSideBar} />
            </CommonProvider>
            <div className="fullpage-footer">
              <Footer />
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default withI18n(PassportMenuPage)
